export default "__VITE_ASSET__73b9a9dd__"